import {
  CREATE_WHATS_APP_FAIL,
  CREATE_WHATS_APP_REQUEST,
  CREATE_WHATS_APP_SUCCESS,
  FETCH_WHATS_APP_FAIL,
  FETCH_WHATS_APP_REQUEST,
  FETCH_WHATS_APP_SUCCESS,
} from "../../ActionType/WhatsAppType/WhatsAppType";

export const createWhatsAppReducer = (
  state = { loading: true, whatsApps: undefined, error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_WHATS_APP_REQUEST:
      return {
        loading: true,
        visits: [],
      };
    case CREATE_WHATS_APP_SUCCESS:

      return {
        loading: false,
        whatsApps: action.payload,
        error: "",
      };
    case CREATE_WHATS_APP_FAIL:
      return {
        loading: false,
        whatsApps: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const getWhatsAppReducer = (
  state = { loading: true, whatsApps: [], total: "", error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_WHATS_APP_REQUEST:
      return {
        loading: true,
        visits: [],
      };
    case FETCH_WHATS_APP_SUCCESS:
      return {
        loading: false,
        whatsApps: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_WHATS_APP_FAIL:
      return {
        loading: false,
        whatsApps: [],
        error: action.error,
      };
    case CREATE_WHATS_APP_SUCCESS:
      return {
        ...state,
        whatsApps: [...state.whatsApps, action.payload], 
        total: state.total + 1, 
      };
    default:
      return state;
  }
};
